import * as React from "react";
import {HistoryEvent} from "../HistoryEvent";
import {WordOracle} from "../WordOracle";
import {FC} from "react";

interface IProps {
    knownCharacters: string,
    history: HistoryEvent[],
    showDebug: boolean,
}

export const DebugData: FC<IProps> = ({knownCharacters, history, showDebug}) => {
    if (!showDebug) {
        return <div/>
    }
    return (
        <div>
            <div>
                <span>Character Priority Order: </span>
                {WordOracle.orderCharacters(knownCharacters, history)}
            </div>
            <div>
                <span>known characters: </span>
                {knownCharacters}
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/DebugData.tsx